import { add, listen, qs, remove, toggle } from '@fluorescent/dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { createFocusTrap } from 'focus-trap';
import PredictiveSearch from '@/lib/predictive-search';

const classes = {
  active: 'active',
  visible: 'visible',
};

export default function (node) {
  const overlay = qs('[data-overlay]', node);
  const input = qs('[data-input]', node);
  const resultsContainer = qs('[data-results]', node);
  const predictiveSearch = PredictiveSearch(resultsContainer);
  const closeButton = qs('[data-close-icon]', node);
  const productsSection = qs('[data-products-section]', node);

  const events = [
    listen([overlay, closeButton], 'click', close),
    listen(input, 'input', handleInput),
    listen(node, 'keydown', ({ keyCode }) => {
      if (keyCode === 27) close();
    }),
  ];

  const trap = createFocusTrap(node, { allowOutsideClick: true });

  function handleInput(e) {
    const value = e.target.value.trim();

    if (value === '') {
      reset();
      return;
    }

    // Show products section when typing
    if (productsSection) {
      productsSection.style.display = '';
    }

    predictiveSearch.getSearchResults(e.target.value);
  }

  // Clear contents of the search input and hide results container
  function reset(e) {
    e && e.preventDefault();
    input.value = '';
    resultsContainer.innerHTML = '';

    // Hide products section on reset (initial state shows only OJO Icons)
    if (productsSection) {
      productsSection.style.display = 'none';
    }

    input.focus();
  }

  function open() {
    add(node, classes.active);
    // Add class to body so CSS can remove backdrop-filter on transparent header
    // (backdrop-filter creates a new stacking context that traps position:fixed children)
    document.body.classList.add('quick-search-open');
    trap.activate();

    // Hide products section initially (show only OJO Icons)
    if (productsSection) {
      productsSection.style.display = 'none';
    }

    setTimeout(() => {
      input.focus();
      disableBodyScroll(node, { reserveScrollBarGap: true });
      add(node, classes.visible);
    }, 50);
  }

  function close() {
    remove(node, classes.visible);
    trap.deactivate();
    document.body.classList.remove('quick-search-open');
    setTimeout(() => {
      remove(node, classes.active);
      enableBodyScroll(node);
    }, 350);
  }

  function destroy() {
    close();

    events.forEach(unsubscribe => unsubscribe());
  }

  return { open, close, destroy };
}
